import { Component, OnInit, OnDestroy } from '@angular/core';
import { SidebarService, SettingsService } from '../../services/service.index';
import { Router, NavigationEnd } from '@angular/router';
import { DataService } from 'src/app/services/shared/dataShare.service';
import { RestApiProvider } from 'src/app/services/shared/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  organizacion: any = {};
  saam_url:string = '';
  isMenuLoading = true;
  private navSubscription?: Subscription;

  constructor(
    public _sidebar: SidebarService, 
    public _settings: SettingsService, 
    private _router: Router,
    private restApi: RestApiProvider,
    private _dataShare: DataService

    ) {
   }

  ngOnInit() {
    this._dataShare.currentMessage.subscribe(message => {
      try {
        this.organizacion['alias'] = message['alias'];
        this.organizacion['id'] = message['id'];
      } catch (err) {}

      if (message && message['message'] === 'loged_in') {
        this._sidebar.loadSideMenu();
      }
      this._settings.cargarAjustes().then(() => {
        this.isMenuLoading = false;
      });
    });

    this.vaciarOrganizacion();

      this._settings.cargarAjustes().then(() => {
        if (this._settings.ajustes.org && this._settings.ajustes.org.id) {
          this.organizacion = this._settings.ajustes.org;
        } else {
          this.vaciarOrganizacion();
      }
      this.isMenuLoading = false;
    });

    this.navSubscription = this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd && window.innerWidth < 1170) {
        this.closeMobileSidebar();
      }
    });
  }

  gotoSaam(){
    // window.open('http://' + this._settings.ajustes.org.urlname + '.localhost:3000', "_blank");
    window.open('https://' + this._settings.ajustes.org.urlname + '.miurabox.com', "_blank"); //Para produccion
  }

  vaciarOrganizacion() {
    this.organizacion = {
      'alias': 'Manager'
    }
  }

  dejarOrganizacion(){
    this._settings.borrarOrg();
    this.vaciarOrganizacion();
    this._dataShare.changeMessage({});
    this._router.navigate(['/organizaciones']);
  }

  closeMobileSidebar() {
    const mainWrapper = document.getElementById('main-wrapper');
    [document.body, mainWrapper].forEach(element => {
      if (element) {
        element.classList.remove('show-sidebar');
        element.classList.add('mini-sidebar');
      }
    });
    this.syncToggleIcons(false);
  }

  ensureSidebarExpanded(event: Event) {
    const mainWrapper = document.getElementById('main-wrapper');
    const body = document.body;
    const isMiniAndHidden = body.classList.contains('mini-sidebar') && !body.classList.contains('show-sidebar');
    if (isMiniAndHidden) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      [body, mainWrapper].forEach(element => {
        if (element) {
          element.classList.remove('mini-sidebar');
          element.classList.add('show-sidebar');
        }
      });
      this.syncToggleIcons(true);
      return true;
    }
    return false;
  }

  handleSidebarLink(menu: any, event: MouseEvent) {
    console.log('menus',menu,event)
    const hasChildren = menu && menu.submenu && menu.submenu.length > 0;
    if (hasChildren) {
      event.preventDefault();
      event.stopPropagation();
      this.ensureSidebarExpanded(event);
      menu.open = !menu.open;
      this.closeOtherMenus(menu);
      return false;
    }
    const didOpen = this.ensureSidebarExpanded(event);
    if (didOpen) {
      return true;
    }
    this.finishSidebarSelection();
    this.closeAllMenus();
    return false;
  }

  private finishSidebarSelection() {
    if (window.innerWidth < 1170) {
      this.closeMobileSidebar();
      return;
    }
    const mainWrapper = document.getElementById('main-wrapper');
    [document.body, mainWrapper].forEach(element => {
      if (element) {
        element.classList.remove('show-sidebar');
        element.classList.add('mini-sidebar');
      }
    });
    this.syncToggleIcons(false);
  }

  private closeOtherMenus(active?: any) {
    if (!this._sidebar.menu) {
      return;
    }
    this._sidebar.menu.forEach(menu => {
      if (menu !== active) {
        menu.open = false;
      }
    });
  }

  private closeAllMenus() {
    if (!this._sidebar.menu) {
      return;
    }
    this._sidebar.menu.forEach(menu => (menu.open = false));
  }

  private syncToggleIcons(isOpen: boolean) {
    const navIcon = document.querySelector('.nav-toggler i');
    if (navIcon) {
      navIcon.classList.toggle('ti-close', isOpen);
      navIcon.classList.toggle('ti-menu', !isOpen);
    }
    this.syncSideIcon(isOpen);
  }

  private syncSideIcon(isOpen: boolean) {
    const sideIcon = document.querySelector('.sidebartoggler i');
    if (sideIcon) {
      sideIcon.classList.toggle('ti-close', isOpen);
      sideIcon.classList.toggle('ti-menu', !isOpen);
    }
  }

  ngOnDestroy() {
    if (this.navSubscription) {
      this.navSubscription.unsubscribe();
    }
  }

}
